<template>
  <div class="selectors">
    <v-select
      item-text="title"
      item-value="value"
      :items="items"
      :label="$t('ifType')"
      solo
      v-model="ifType"
    ></v-select>
    <div v-if="ifType == 'device'">
      <v-select
        :items="allDevices"
        v-model="sensorVal"
        item-text="name"
        item-value="identifier"
        :label="$t('sensorSelect')"
      ></v-select>
      <v-select
        :items="sensorDevices"
        v-model="sensorDeviceVal"
        :label="$t('sensorDevSelect')"
      ></v-select>
      <v-select
        v-if="
          sensorVal == null ||
          ((device(sensorVal).type < 11 || device(sensorVal).type > 14) &&
            device(sensorVal).type != 21 &&
            device(sensorVal).type != 7)
        "
        :items="actions"
        v-model="ifAction"
        :label="$t('ifs')"
      ></v-select>

      <v-radio-group
        v-model="ifAction"
        row
        v-else-if="device(sensorVal).type == 7"
      >
        <v-radio
          class="radio"
          color="primary"
          :label="$t('lightOn')"
          value="1"
        ></v-radio>
        <v-radio
          class="radio"
          color="primary"
          :label="$t('lightOff')"
          value="0"
        ></v-radio>
      </v-radio-group>
      <v-radio-group
        v-model="ifAction"
        row
        v-else-if="device(sensorVal).type == 21"
      >
        <v-radio
          class="radio"
          color="primary"
          :label="$t('vibrate')"
          value="1"
        ></v-radio>
        <v-radio
          class="radio"
          color="primary"
          :label="$t('steady')"
          value="0"
        ></v-radio>
      </v-radio-group>
      <v-radio-group
        v-model="ifAction"
        row
        v-else-if="device(sensorVal).type >= 11 && device(sensorVal).type <= 14"
      >
        <v-radio
          class="radio"
          color="primary"
          :label="$t('open')"
          value="0"
        ></v-radio>
        <v-radio
          class="radio"
          color="primary"
          :label="$t('close')"
          value="1"
        ></v-radio>
      </v-radio-group>

      <v-radio-group
        v-model="radioVal"
        row
        v-if="
          sensorVal == null ||
          ((device(sensorVal).type <= 10 || device(sensorVal).type > 14) &&
            device(sensorVal).type != 21 &&
            device(sensorVal).type != 7)
        "
      >
        <v-radio :label="$t('staticTemp')" value="staticTemp"></v-radio>
        <v-radio :label="$t('toDeviceTemp')" value="toDeviceTemp"></v-radio>
      </v-radio-group>
      <v-text-field
        v-if="radioVal == 'staticTemp'"
        type="Number"
        :label="$t(sensorDeviceVal)"
        v-model="tempVal"
      ></v-text-field>
      <v-select
        v-if="radioVal == 'toDeviceTemp'"
        :items="deviceSelector"
        item-text="name"
        item-value="identifier"
        v-model="toSensorVal"
        :label="$t('sensorSelect')"
      ></v-select>
    </div>

    <div class="d-flex flex-column" v-if="ifType == 'time'">
      <h3 class="ms-2 text-decoration-underline">
        {{ $t("scheduale") }}
      </h3>
      <v-radio-group class="mt-2" v-model="schedVal" row>
        <!-- <v-radio :label="$t('24/7')" value="24/7"></v-radio> -->
        <v-radio :label="$t('dayTime')" value="dayTime"></v-radio>
      </v-radio-group>

      <v-layout row wrap>
        <v-btn-toggle
          :class="
            $vuetify.breakpoint.xs ? 'mb-2 justify-center' : 'mb-2 mx-auto'
          "
          v-model="toggle_days"
          v-if="schedVal == 'dayTime'"
          multiple
        >
          <v-btn value="sunday">
            {{ $t("weekDays.sunday") }}
          </v-btn>
          <v-btn value="monday">
            {{ $t("weekDays.monday") }}
          </v-btn>
          <v-btn value="tuesday">
            {{ $t("weekDays.tuesday") }}
          </v-btn>
          <v-btn value="wednesday">
            {{ $t("weekDays.wednesday") }}
          </v-btn>
          <v-btn value="thursday">
            {{ $t("weekDays.thursday") }}
          </v-btn>
          <v-btn value="friday">
            {{ $t("weekDays.friday") }}
          </v-btn>
          <v-btn value="saturday">
            {{ $t("weekDays.saturday") }}
          </v-btn>
        </v-btn-toggle>
      </v-layout>
      <v-layout v-if="schedVal == 'dayTime'" row wrap>
        <v-dialog
          ref="startDialog"
          v-model="startTime"
          :return-value.sync="startTimeVal"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startTimeVal"
              :label="$t('startTime')"
              prepend-icon="mdi-clock-time-four-outline"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            format="24hr"
            v-if="startTime"
            v-model="startTimeVal"
            full-width
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="startTime = false">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.startDialog.save(startTimeVal)"
            >
              {{ $t("confirm") }}
            </v-btn>
          </v-time-picker>
        </v-dialog>
        <v-dialog
          ref="endDialog"
          v-model="endTime"
          :return-value.sync="endTimeVal"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endTimeVal"
              :label="$t('endTime')"
              prepend-icon="mdi-clock-time-four-outline"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            format="24hr"
            v-if="endTime"
            v-model="endTimeVal"
            full-width
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="endTime = false">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.endDialog.save(endTimeVal)"
            >
              {{ $t("confirm") }}
            </v-btn>
          </v-time-picker>
        </v-dialog>
      </v-layout>
    </div>

    <div v-if="ifType == 'connection'">
      <v-select
        :items="allDevices"
        v-model="sensorVal"
        item-text="name"
        item-value="identifier"
        :label="$t('sensorSelect')"
      ></v-select>
      <v-layout row wrap justify-center>
        <span class="title-h5">{{ this.$t("connection-status") }}:</span>
        <v-radio-group v-model="deviceConnection" row>
          <v-radio :label="$t('online')" value="online" />
          <v-radio :label="$t('offline')" value="offline" />
        </v-radio-group>
      </v-layout>
    </div>

    <div v-if="ifType == 'output'">
      <v-select
        :items="controllerDevices"
        v-model="sensorVal"
        item-text="name"
        item-value="identifier"
        :label="$t('controllerSelect')"
      ></v-select>
      <v-layout row wrap justify-center>
        <span class="title-h5">{{ this.$t("controller-output") }}:</span>
        <v-radio-group v-model="controllerOutput" row>
          <v-radio :label="$t('controllerOn')" value="on" />
          <v-radio :label="$t('controllerOff')" value="off" />
        </v-radio-group>
      </v-layout>
    </div>

    <div v-if="ifType == 'rssi'" class="mb-8">
      <v-select
        :items="onlyDevices"
        v-model="sensorVal"
        item-text="name"
        item-value="identifier"
        :label="$t('sensorSelect')"
      ></v-select>
      <v-layout row wrap align-center justify-center v-if="sensorVal">
        <span class="title-h5">{{ this.$t("by") }}:</span>
        <v-btn-toggle
          v-model="signalType"
          tile
          color="deep-purple accent-3"
          group
        >
          <v-btn value="best">
            {{ $t("best") }}
          </v-btn>

          <v-btn
            value="choose"
            :disabled="disableMulti"
            :class="disableMulti ? 'text-decoration-line-through' : ''"
          >
            {{ $t("choose") }}
          </v-btn>
        </v-btn-toggle>
      </v-layout>
      <v-select
        v-if="signalType == 'choose'"
        :items="mappedGateways"
        v-model="gateVal"
        item-text="name"
        item-value="identifier"
        :label="$t('gatewaySelect')"
      ></v-select>
      <v-layout v-if="signalType" row wrap align-center justify-center>
        <span class="title-h5">{{ this.$t("signal-strength") }}:</span>
        <v-btn-toggle
          v-model="signalStrength"
          tile
          color="deep-purple accent-3"
          group
        >
          <v-btn value="poor">
            {{ $t("poor") }}
          </v-btn>

          <v-btn value="weak">
            {{ $t("weak") }}
          </v-btn>

          <v-btn value="fine">
            {{ $t("fine") }}
          </v-btn>
          <v-btn value="good">
            {{ $t("good") }}
          </v-btn>
          <v-btn value="excellent">
            {{ $t("excellent") }}
          </v-btn>
        </v-btn-toggle>
      </v-layout>
    </div>
    <div v-if="ifType == 'gateway_rssi'" class="mb-8">
      <v-select
        :items="mappedGateways"
        v-model="gatewayRssi"
        item-text="name"
        item-value="identifier"
        :label="$t('gatewaySelect')"
      ></v-select>
      <v-select
        :disabled="!gatewayRssi"
        :items="onlyDevices"
        v-model="gatewayRssiSensors"
        item-text="name"
        item-value="identifier"
        :label="$t('sensorsSelect')"
        multiple
        chips
        deletable-chips
        counter
        class="purple-chips"
        item-color="switchq"
      ></v-select>
      <div class="w-100" style="max-width: 800px">
        <div class="d-flex flex-row justify-space-between">
          <label>{{ $t("signal-strength") }}</label>
          <span class="text-subtitle-2">
            {{
              $t("from-to", {
                start: forceLTR(gatewayRssiRange[0]),
                end: forceLTR(gatewayRssiRange[1]),
              })
            }}
          </span>
        </div>
        <v-range-slider
          v-model="gatewayRssiRange"
          :disabled="!gatewayRssiSensors.length"
          persistent-hint
          inverse-label
          max="0"
          min="-120"
          class="mt-4"
          style="max-width: 800px"
        />
      </div>
    </div>

    <v-layout row wrap justify-center class="my-4 mb-2">
      <v-btn color="primary" class="mx-8" @click="confirmIf">
        {{ $t("confirm") }}
      </v-btn>
      <v-btn @click="close" class="mx-8">
        {{ $t("cancel") }}
      </v-btn>
    </v-layout>
  </div>
</template>
<script>
export default {
  name: "automationsIfs",
  props: {
    config: {
      type: Boolean,
      default: false,
    },
    configData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      deviceSelector: [],
      sensorDeviceVal: null,
      disableMulti: null,
      sensorVal: null,
      gatewayRssi: null,
      gatewayRssiSensors: [],
      gatewayRssiRange: [-120, 0],
      gateVal: null,
      toSensorVal: null,
      ifDelay: false,
      delayTime: null,
      ifAction: null,
      ifType: null,
      signalType: null,
      items: [
        { title: this.$t("byTime"), value: "time" },
        { title: this.$t("byDevice"), value: "device" },
        { title: this.$t("byConnect"), value: "connection" },
        { title: this.$t("byRssi"), value: "rssi" },
        { title: this.$t("byGatewayRssi"), value: "gateway_rssi" },
        { title: this.$t("byOutput"), value: "output" },
      ],
      deviceConnection: "online",
      controllerOutput: "on",
      signalStrength: "excellent",
      radioVal: null,
      schedVal: "dayTime",
      endTimeVal: "23:59",
      startTimeVal: "00:00",
      startTime: null,
      endTime: null,
      toggle_days: [],

      actionVal: null,
      tempVal: null,
    };
  },
  computed: {
    automations() {
      let automations = this.$store.getters["automations/automationsObj"];
      return automations;
    },

    allDevices() {
      let devices = this.$store.getters["devices/devices"];
      Object.values(devices).filter((d) => {
        return d.role == 0 &&
          this.sensorDeviceVal &&
          "sensors" in d.data &&
          this.sensorDeviceVal in d.data.sensors
          ? this.deviceSelector.push({
              name: d.name,
              slug: d.slug,
              identifier: d.identifier,
              sensors: Object.keys(d.data.sensors),
              type: d.settings.sensor_type,
            })
          : "";
      });
      return Object.values(devices).map((d) => {
        return {
          name: d.name,
          slug: d.slug,
          identifier: d.identifier,
          sensors:
            d.data && "sensors" in d.data ? Object.keys(d.data.sensors) : [],
          type: d.settings.sensor_type,
        };
      });
    },
    onlyDevices() {
      let devices = this.$store.getters["devices/devices"];
      return Object.values(devices).map((d) => {
        // console.log("d", d);
        if (d.data.signal) {
          return {
            name: d.name,
            slug: d.slug,
            identifier: d.identifier,
            sensors: Object.keys(d.data.sensors),
            type: d.settings.sensor_type,
          };
        }
      });
    },
    gateways() {
      let gateways = this.$store.getters["devices/gateways"];
      return Object.values(gateways);
    },
    gatewaysNames() {
      return this.$store.getters["devices/gNames"];
    },
    mappedGateways() {
      return this.gateways.map((gateway) => {
        gateway.totalDevices = gateway.devices.length;
        gateway.avgRssi =
          gateway.devices.reduce((total, next) => total + next.rssi, 0) /
          gateway.devices.length;
        gateway.avgRssi = Number(gateway.avgRssi).toFixed(0);
        gateway.name =
          this.gatewaysNames.filter((g) => g.gateway === gateway.identifier)
            .name ?? gateway.identifier;
        return gateway;
      });
    },
    controllerDevices() {
      let devices = this.$store.getters["devices/devices"];
      return Object.values(devices).map((d) => {
        if (d.role == 1) {
          return {
            name: d.name,
            slug: d.slug,
            identifier: d.identifier,
            sensors: Object.keys(d.data.sensors),
            type: d.settings.sensor_type,
          };
        }
      });
    },
    sensorDevices() {
      let sensors = [
        {
          value: "temperatures",
          text: this.$t("temperature"),
        },
        {
          value: "humidity",
          text: this.$t("humidity"),
        },
        {
          value: "range",
          text: this.$t("range"),
        },
        {
          value: "light",
          text: this.$t("light"),
        },
        {
          value: "isVibrating",
          text: this.$t("isVibrating"),
        },
        {
          value: "hall",
          text: this.$t("hall"),
        },
        {
          value: "water",
          text: this.$t("water"),
        },
        {
          value: "drycontact",
          text: this.$t("drycontact"),
        },
        {
          value: "pressure",
          text: this.$t("pressure"),
        },
        {
          value: "co2",
          text: this.$t("co2"),
        },
      ];
      if (this.sensorVal) {
        const deviceSensors = this.allDevices.filter(
          (d) => d.identifier == this.sensorVal
        )[0].sensors;
        return sensors.filter((s) => deviceSensors.includes(s.value));
      } else {
        return [];
      }
    },
    actions() {
      return [
        {
          value: ">",
          text: this.$t("bigger"),
        },
        {
          value: "<",
          text: this.$t("smaller"),
        },
        {
          value: "==",
          text: this.$t("equals"),
        },
        {
          value: "!=",
          text: this.$t("not-equals"),
        },
      ];
    },
  },
  mounted() {
    if (this.config) {
      if (this.configData.output) {
        this.ifType = "output";
        this.sensorVal = this.configData.output.if_controller;
        this.controllerOutput = this.configData.output.if_output;
      } else if (this.configData.connection) {
        this.ifType = "connection";
        this.sensorVal = this.configData.connection.if_sensor;
        this.deviceConnection = this.configData.connection.if_connect;
      } else if (this.configData.rssi) {
        this.ifType = "rssi";
        this.sensorVal = this.configData.rssi.if_sensor;
        this.signalStrength = this.configData.rssi.if_strength;
        this.signalType = this.configData.rssi.if_signalType;
        this.gateVal = this.configData.rssi.if_gateway ?? null;
      } else if (this.configData.gateway_rssi) {
        this.ifType = "gateway_rssi";
        this.gatewayRssi = this.configData.gateway_rssi.if_gateway;
        this.gatewayRssiSensors = this.configData.gateway_rssi.devices;
        this.gatewayRssiRange[0] =
          this.configData.gateway_rssi.if_bottom_threshold;
        this.gatewayRssiRange[1] =
          this.configData.gateway_rssi.if_top_threshold;
      } else if (this.configData.device) {
        this.ifType = "device";
        this.sensorVal = this.configData.device.if_sensor;
        this.sensorDeviceVal = this.configData.device.if_sensorDevice;
        this.ifAction = this.configData.device.if_action ?? null;
        this.radioVal = this.configData.device.state ?? null;
        if (
          (this.device(this.sensorVal).type <= 10 ||
            this.device(this.sensorVal).type > 14) &&
          this.device(this.sensorVal).type != 21 &&
          this.device(this.sensorVal).type != 7
        ) {
          this.configData.device.to_state.length <= 3
            ? (this.tempVal = this.configData.device.to_state)
            : (this.toSensorVal = this.configData.device.to_state);
        } else {
          this.tempVal = null;
          this.toSensorVal = null;
        }
      } else if (this.configData.scheduale) {
        this.ifType = "time";
        if (this.configData.scheduale.time) {
          this.schedVal = "dayTime";
        } else {
          this.schedVal = "dayTime";
          this.endTimeVal = this.configData.scheduale.endTime;
          this.startTimeVal = this.configData.scheduale.startTime;
          this.toggle_days = this.configData.scheduale.days;
        }
      }
    } else {
      this.ifType = null;
      this.sensorDeviceVal = null;
      this.sensorVal = null;
      this.toSensorVal = null;
      this.ifAction = null;
      this.radioVal = null;
      this.actionVal = null;
      this.tempVal = null;
      this.schedVal = "dayTime";
      this.endTimeVal = "23:59";
      this.startTimeVal = "00:00";
      this.endTime = null;
      this.startTime = null;
      this.toggle_days = [];
      this.signalType = null;
      this.controllerOutput = "on";
      this.deviceConnection = "online";
      this.signalStrength = "excellent";
      this.gatewayRssi = null;
      this.gatewayRssiSensors = [];
      this.gatewayRssiRange = [-120, 0];
    }
  },
  watch: {
    sensorVal: {
      handler() {
        if (this.sensorVal) {
          let device = this.$store.getters["devices/device"](
            this.allDevices.filter((d) => d.identifier == this.sensorVal)[0]
          );
          if (device && Object.values(device.data.signal).length <= 1) {
            this.disableMulti = true;
            this.signalType = "best";
          } else {
            if (!this.configData) {
              this.disableMulti = false;
              this.signalType = null;
            }
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    device(identifier) {
      return this.allDevices.filter((d) => d.identifier == identifier)[0];
    },
    forceLTR(text) {
      return `\u202A${text}\u202C`;
    },
    alertError(msg) {
      this.$store.dispatch("general/setAlert", {
        type: "oops",
        msg: msg,
      });
    },

    close() {
      this.sensorDeviceVal = null;
      this.deviceConnection = "online";
      this.controllerOutput = "on";
      this.sensorVal = null;
      this.toSensorVal = null;
      this.ifAction = null;
      this.ifType = null;
      this.radioVal = null;
      this.actionVal = null;
      this.tempVal = null;
      this.schedVal = "dayTime";
      this.endTimeVal = "23:59";
      this.startTimeVal = "00:00";
      this.endTime = null;
      this.startTime = null;
      this.toggle_days = [];
      this.$emit("closeForm");
    },
    async confirmIf() {
      let scheduale = {};
      let device = {};
      let connection = {};
      let output = {};
      let rssi = {};
      let data = {};

      if (this.ifType == "time") {
        if (this.toggle_days.length == 0 || this.schedVal == null) {
          this.alertError("mustFill");
        } else {
          if (this.schedVal == "dayTime") {
            scheduale.startTime = this.startTimeVal;
            scheduale.endTime = this.endTimeVal;
            scheduale.days = this.toggle_days;
          }
          data = {
            scheduale: Object.values(scheduale).length > 0 ? scheduale : null,
          };
          if (!this.config) {
            this.$emit("createNewIf", data);
          } else {
            this.$emit("updateNewIf", data);
          }
          this.close();
        }
      } else if (this.ifType == "device") {
        if (
          this.sensorVal &&
          (this.device(this.sensorVal).type <= 10 ||
            this.device(this.sensorVal).type > 14) &&
          this.device(this.sensorVal).type != 21 &&
          this.device(this.sensorVal).type != 7
        ) {
          if (
            (this.sensorVal &&
              this.sensorDeviceVal &&
              this.ifAction &&
              this.radioVal &&
              this.tempVal) ||
            (this.sensorVal &&
              this.sensorDeviceVal &&
              this.ifAction &&
              this.radioVal &&
              this.toSensorVal)
          ) {
            device = {
              if_sensor: this.sensorVal,
              if_sensorDevice: this.sensorDeviceVal,
              if_action: this.ifAction,
              state: this.radioVal,
              to_state: this.tempVal ? this.tempVal : this.toSensorVal,
            };
            data = {
              device: device,
            };
            if (!this.config) {
              this.$emit("createNewIf", data);
            } else {
              this.$emit("updateNewIf", data);
            }
            this.close();
          } else {
            this.alertError("mustFill");
          }
        } else {
          if (this.sensorVal && this.sensorDeviceVal && this.ifAction) {
            device = {
              if_sensor: this.sensorVal,
              if_sensorDevice: this.sensorDeviceVal,
              if_action: this.ifAction,
            };
            data = {
              device: device,
            };
            if (!this.config) {
              this.$emit("createNewIf", data);
            } else {
              this.$emit("updateNewIf", data);
            }
            this.close();
          } else {
            this.alertError("mustFill");
          }
        }
      } else if (this.ifType == "connection") {
        if (this.sensorVal && this.deviceConnection) {
          connection = {
            if_sensor: this.sensorVal,
            if_connect: this.deviceConnection,
          };
          data = {
            connection: connection,
          };
          if (!this.config) {
            this.$emit("createNewIf", data);
          } else {
            this.$emit("updateNewIf", data);
          }
          this.close();
        } else {
          this.alertError("mustFill");
        }
      } else if (this.ifType == "output") {
        if (this.sensorVal && this.controllerOutput) {
          output = {
            if_controller: this.sensorVal,
            if_output: this.controllerOutput,
          };
          data = {
            output: output,
          };
          if (!this.config) {
            this.$emit("createNewIf", data);
          } else {
            this.$emit("updateNewIf", data);
          }
          this.close();
        } else {
          this.alertError("mustFill");
        }
      } else if (this.ifType == "rssi") {
        if (this.sensorVal && this.signalType && this.signalStrength) {
          rssi = {
            if_sensor: this.sensorVal,
            if_signalType: this.signalType,
            if_strength: this.signalStrength,
            if_gateway: this.gateVal ?? null,
          };
          data = {
            rssi: rssi,
          };
          if (!this.config) {
            this.$emit("createNewIf", data);
          } else {
            this.$emit("updateNewIf", data);
          }
          this.close();
        } else {
          this.alertError("mustFill");
        }
      } else if (this.ifType == "gateway_rssi") {
        if (
          this.gatewayRssi &&
          this.gatewayRssiSensors &&
          this.gatewayRssiRange
        ) {
          rssi = {
            if_gateway: this.gatewayRssi,
            devices: this.gatewayRssiSensors,
            if_bottom_threshold: this.gatewayRssiRange[0],
            if_top_threshold: this.gatewayRssiRange[1],
          };
          data = {
            gateway_rssi: rssi,
          };
          if (!this.config) {
            this.$emit("createNewIf", data);
          } else {
            this.$emit("updateNewIf", data);
          }
          this.close();
        } else {
          this.alertError("mustFill");
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pageHeader {
  display: flex;
  flex-direction: column;
  width: fit-content;
  align-items: center;
  margin: 0 auto;
}
.vertDivider {
  color: red;
}

.autoNameField {
  margin: 0 auto;
  padding-top: 50px;
  width: 85%;
}

.selectors {
  padding-top: 20px;
  margin: 0 auto;
  width: 85%;
}

.autoCard {
  width: 85%;
  text-align: start;
  .v-card__title {
    margin-inline-start: -14px;
    margin-inline-end: -14px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
  }
  .delIcon {
    display: flex;
    .v-icon {
      cursor: pointer;
      color: red;
    }
  }
}
.v-input--selection-controls {
  margin-top: unset;
  padding-top: unset;
}
</style>
<style lang="scss">
.purple-chips .v-chip {
  background-color: rgba(122, 0, 204, 0.2) !important;
}
</style>
